import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Landing from './pages/Landing';
import Dashboard from './pages/Dashboard';
import Upload from './pages/Upload';
import Categories from './pages/Categories';
import HighValue from './pages/HighValue';
import Rewards from './pages/Rewards';
import Admin from './pages/Admin';
import Layout from './components/Layout';
import { Toaster } from './components/ui/sonner';
import { FilterProvider } from './context/FilterContext';
import './App.css';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isAdminAuthenticated, setIsAdminAuthenticated] = useState(false);

  const handleAuth = () => {
    setIsAuthenticated(true);
  };

  const handleAdminAuth = () => {
    setIsAdminAuthenticated(true);
  };

  const handleLogout = () => {
    setIsAuthenticated(false);
  };

  const handleAdminLogout = () => {
    setIsAdminAuthenticated(false);
    sessionStorage.removeItem('admin_password');
  };

  // Check for admin session on mount
  useEffect(() => {
    const adminPassword = sessionStorage.getItem('admin_password');
    if (adminPassword) {
      setIsAdminAuthenticated(true);
    }
  }, []);

  // Admin route takes priority
  if (isAdminAuthenticated) {
    return (
      <>
        <BrowserRouter>
          <Routes>
            <Route path="*" element={<Admin onLogout={handleAdminLogout} />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" />
      </>
    );
  }

  return (
    <FilterProvider>
      <BrowserRouter>
        <Routes>
          <Route
            path="/"
            element={
              !isAuthenticated ? (
                <Landing onAuth={handleAuth} onAdminAuth={handleAdminAuth} />
              ) : (
                <Navigate to="/dashboard" replace />
              )
            }
          />
          <Route
            path="/*"
            element={
              isAuthenticated ? (
                <Layout onLogout={handleLogout}>
                  <Routes>
                    <Route path="/dashboard" element={<Dashboard />} />
                    <Route path="/upload" element={<Upload />} />
                    <Route path="/categories" element={<Categories onLogout={handleLogout} />} />
                    <Route path="/high-value" element={<HighValue />} />
                    <Route path="/rewards" element={<Rewards />} />
                  </Routes>
                </Layout>
              ) : (
                <Navigate to="/" replace />
              )
            }
          />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" />
    </FilterProvider>
  );
}

export default App;